
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "component-no-shop-banner",
  props: {
    type: {
      type: String,
      default: "fixed",
      validator: (value: string) => {
        return ["fixed", "float"].includes(value);
      },
    },
    title: String,
    subtitle: String,
    hideLeftIcon: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters("ui", ["isMobile"]),
  },
});
